<template>
    <v-flex class="pl-2 mb-4 mt-2 row" xs12>
        <v-icon left medium>{{icon}}</v-icon>
        <span class="font-weight-bold" style="color: black; font-size: 19px;">
                           {{text}}</span>
    </v-flex>
</template>

<script>
    export default {
        name: "HeaderText",
        props: {
            text: {
                type: [String, Number, Boolean],
                default: false
            },
            icon: {
                type: [String],
                default: ''
            },
        },
    }
</script>
